<section class="py-3">
  <div class="container-fluid card">
    <div class="row align-items-center justify-content-between g-2 mb-2">
      <div class="col-12 col-md-3">
        <app-main-heading [heading]="'Tyre Size'" class="m-0"></app-main-heading>
      </div>
      <div class="col-12 col-md-9">
        <div class="row g-2 align-items-center justify-content-end">
          <div class="col-12 col-sm-6 col-md-4">
            <div class="search-wrapper position-relative w-100">
              <input type="text" class="form-control search-input" placeholder="Search..."
                style="border-radius: 8px; padding-left: 35px; height: 38px; border: 1.5px solid #E2E8F0; font-size: 13px;"
                #searchTerm (input)="onSearchInput(searchTerm.value)">
              <fa-icon [icon]="faSearch" class="position-absolute start-0 top-50 translate-middle-y ms-3 text-muted"
                style="pointer-events: none; font-size: 13px;"></fa-icon>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            @if (isAdmin) {
              <button class="btn app-btn-primary w-100" style="height: 38px; display: flex; align-items: center; justify-content: center;" (click)="tyreAddFormPopup()">
                Add Tyre Size
              </button>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="card app-table-thick-border shadow-none">
      <div class="table-responsive" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="500" (scrolled)="onScroll()">
        <table class="table app-table-rounded align-middle m-0 w-100">
          <thead>
            <tr class="app-table-header text-nowrap">
              <th scope="col" sortable="">Tyre Size</th>
              <th scope="col" sortable="">Rim Size</th>
              <th scope="col" sortable="">Aspect Ratio</th>
              <th scope="col" sortable="">Cons. Type</th>
              <th scope="col" sortable="">Category</th>
              @if (isCompanyUser) {
                <th scope="col">
                  <div class="action-cell">Action</div>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @if (tyreList.length > 0) {
              @for (list of tyreList; track list) {
                <tr class="app-table-body app-td-text">
                  <td class="td-text-three fw-bold">{{list.tyreSize}}</td>
                  <td class="td-text-two">{{list.rimSize}}</td>
                  <td class="td-text-two">{{list.aspectRatio}}</td>
                  <td class="td-text-one fw-bold">{{list.constructionType}}</td>
                  <td class="td-text-one">{{list.category}}</td>
                  @if (isCompanyUser) {
                    <td>
                      <div class="d-flex justify-content-evenly">
                        <fa-icon [icon]="faEdit" (click)="editData(list._id)" class="btn app-btn-primary btn-sm" ngbTooltip="Edit"
                          [placement]="'left'"></fa-icon> &nbsp;
                      </div>
                    </td>
                  }
                </tr>
              }
            }

            @if (loader) {
              <tr>
                <td [attr.colspan]="isCompanyUser ? 6 : 5">
                  <div class="custom-col-width-100 d-flex justify-content-center py-5">
                    <app-loader [loadingIcon]="loader"></app-loader>
                  </div>
                </td>
              </tr>
            }

            @if (!loader && tyreList.length === 0) {
              <tr>
                <td [attr.colspan]="isCompanyUser ? 6 : 5">
                  <div class="custom-col-width-100 text-danger d-flex justify-content-center py-5 fw-semibold">
                    No Records Found!
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>



  @if (showEditMakePopup) {
  <div class="popup-overlay">
    <div class="popup-container">
      <h3>Add Tyre Size</h3>
      <form (ngSubmit)="saveTyreData()" [formGroup]="addTyreForm">
        <div class="row px-3 g-3">
          <div class="col-12 col-md-6 mb-3">
            <label for="category" class="form-label">Vehicle Type<span class="text-danger">*</span></label>
            <select class="form-select default-form-group-border" id="category" formControlName="category"
              (change)="onChangeVehical($event)">
              <option value="" disabled>Select Vehical Type</option>
              @for (vehical of vehicleFormats; track vehical) {
              <option [value]="vehical.id">
                {{vehical.name}}</option>
              }
            </select>
            @if (addTyreForm.get('category')?.invalid && (addTyreForm.get('category')?.dirty ||
            addTyreForm.get('category')?.touched)) {
            <div class="errorText">
              @if (addTyreForm.get('category')?.errors?.['required']) {
              <div>
                <small class="text-danger">Vehical type is required</small>
              </div>
              }
            </div>
            }
          </div>
          @if (visibleFields.crossSectionWidth.visible) {
          <div class="col-12 col-md-6 mb-3">
            <label for="crossSectionWidth" class="form-label">Width @if (visibleFields.crossSectionWidth.required) {
              <span class="text-danger">*</span>
              }</label>
            <input type="text" class="form-control default-form-group-border" id="crossSectionWidth"
              formControlName="crossSectionWidth" placeholder="Eg: 195" type="number">
            @if (addTyreForm.get('crossSectionWidth')?.invalid &&
            (addTyreForm.get('crossSectionWidth')?.dirty || addTyreForm.get('crossSectionWidth')?.touched)) {
            <div class="errorText">
              @if (addTyreForm.get('crossSectionWidth')?.errors?.['required']) {
              <div>
                <small class="text-danger">width is required</small>
              </div>
              }
            </div>
            }
          </div>
          }
          @if (visibleFields.aspectRatio.visible) {
          <div class="col-12 col-md-6 mb-3">
            <label for="aspectRatio" class="form-label">Aspect Ratio @if (visibleFields.aspectRatio.required) {
              <span class="text-danger">*</span>
              }</label>
            <input type="text" class="form-control default-form-group-border" id="aspectRatio"
              formControlName="aspectRatio" placeholder="Eg: 100" type="number">
            @if (addTyreForm.get('aspectRatio')?.invalid && (addTyreForm.get('aspectRatio')?.dirty ||
            addTyreForm.get('aspectRatio')?.touched)) {
            <div class="errorText">
              @if (addTyreForm.get('aspectRatio')?.errors?.['required']) {
              <div>
                <small class="text-danger">Aspect ratio is required</small>
              </div>
              }
            </div>
            }
          </div>
          }
          @if (visibleFields.constructionType.visible) {
          <div class="col-12 col-md-6 mb-3">
            <label for="constructionType" class="form-label">Tyre Construction @if (visibleFields.constructionType.required) {
              <span class="text-danger">*</span>
              }</label>
            <input type="text" class="form-control default-form-group-border" id="constructionType"
              formControlName="constructionType" placeholder="Eg: R" type="text" (input)="input($event)">
            @if (addTyreForm.get('constructionType')?.invalid && (addTyreForm.get('constructionType')?.dirty
            || addTyreForm.get('constructionType')?.touched)) {
            <div class="errorText">
              @if (addTyreForm.get('constructionType')?.errors?.['required']) {
              <div>
                <small class="text-danger">Tyre construction is required</small>
              </div>
              }
            </div>
            }
          </div>
          }
          @if (visibleFields.rimSize.visible) {
          <div class="col-12 col-md-6 mb-3">
            <label for="rimSize" class="form-label">Rim Size@if (visibleFields.rimSize.required) {
              <span class="text-danger">*</span>
              }</label>
            <input type="text" class="form-control default-form-group-border" id="rimSize" formControlName="rimSize"
              placeholder="Eg: 95" type="number">
            @if (addTyreForm.get('rimSize')?.invalid && (addTyreForm.get('rimSize')?.dirty ||
            addTyreForm.get('rimSize')?.touched)) {
            <div class="errorText">
              @if (addTyreForm.get('rimSize')?.errors?.['required']) {
              <div>
                <small class="text-danger">Rim size is required</small>
              </div>
              }
            </div>
            }
          </div>
          }
          @if (visibleFields.commercialTyre.visible) {
          <div class="col-12 col-md-6 mb-3">
            <label for="commercialTyre" class="form-label">Commercial Tyre@if (visibleFields.commercialTyre.required) {
              <span class="text-danger">*</span>
              }</label>
            <input type="text" class="form-control default-form-group-border" id="commercialTyre"
              formControlName="commercialTyre" placeholder="Eg: C" type="text" (input)="commertialInput($event)">
            @if (addTyreForm.get('commercialTyre')?.invalid && (addTyreForm.get('commercialTyre')?.dirty ||
            addTyreForm.get('commercialTyre')?.touched)) {
            <div class="errorText">
              @if (addTyreForm.get('commercialTyre')?.errors?.['required']) {
              <div>
                <small class="text-danger">Tyre construction is required</small>
              </div>
              }
            </div>
            }
          </div>
          }
          @if (visibleFields.profile.visible) {
          <div class="col-12 col-md-6 mb-3">
            <label for="profile" class="form-label">Profile / Side Wall@if (visibleFields.profile.required) {
              <span class="text-danger">*</span>
              }</label>
            <input type="text" class="form-control default-form-group-border" id="profile" formControlName="profile"
              placeholder="profile" type="number">
            @if (addTyreForm.get('profile')?.invalid && (addTyreForm.get('profile')?.dirty ||
            addTyreForm.get('profile')?.touched)) {
            <div class="errorText">
              @if (addTyreForm.get('profile')?.errors?.['required']) {
              <div>
                <small class="text-danger">Profile/Side Wall is required</small>
              </div>
              }
            </div>
            }
          </div>
          }
          @if (!this.isAdmin) {
          <div class="col-12 col-md-4 mb-3">
            <label for="maxAmount" class="form-label">Maximum Amount</label>
            <input formControlName="maxAmount" id="maxAmount" type="text" class="form-control default-form-group-border"
              placeholder="Enter maximum amount" type="number">
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label for="minAmount" class="form-label">Minimum Amount</label>
            <input formControlName="minAmount" id="minAmount" type="text" class="form-control default-form-group-border"
              placeholder="Enter minimum amount" type="number">
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label for="profitability" class="form-label">Profitability</label>
            <input formControlName="profitability" id="profitability" type="text"
              class="form-control default-form-group-border" placeholder="Enter profitability amount" type="number">
          </div>
          }
        </div>
        @if (responseMsg) {
        <div class="text-danger">{{responseMsg}}</div>
        }
        <!-- Action Buttons -->
        <div class="row pt-3">
          <div class="col-12 d-flex justify-content-end gap-2 button_section">
            <button type="button" class="btn pr-2" (click)="closePopup()">Cancel</button>
            <button type="submit" class="btn app-btn-primary sub_button" [disabled]="!addTyreForm.valid">
              Add
              @if (isLoading) {
                <output class="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output>
              }
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  }
</section>

@if (isToster) {
<app-toaster [title]="message" (closeToaster)="closeToster($event)"></app-toaster>
}